import React from "react";
import { Link } from "react-router-dom";

export default function FinanceInfo({ financeData }) {
  return (
      <div className="dashboard_card">
        <ul className="dashboard_list">
          <li>
            <div className="dashboard_num">
              <h3>{financeData?.total_income}</h3>
              <h5>Total Income</h5>
              <Link to={`#`} className="view_link">
                View All <img src={"/assets/images/viewall.svg"} alt="" />
              </Link>
            </div>
          </li>

          <li>
            <div className="dashboard_num">
              <h3>{financeData?.total_gst_paid}</h3>
              <h5>Total GST Paid</h5>
              <Link to={`#`} className="view_link">
                View All <img src={"/assets/images/viewall.svg"} alt="" />
              </Link>
            </div>
          </li>

          <li>
            <div className="dashboard_num">
              <h3>{financeData?.prepaid_collection}</h3>
              <h5>Pre Paid Colleaction</h5>
              <Link to={`#`} className="view_link">
                View All <img src={"/assets/images/viewall.svg"} alt="" />
              </Link>
            </div>
          </li>

          <li>
            <div className="dashboard_num">
              <h3>{financeData?.monthly_plan_collection}</h3>
              <h5>Monthly Plan Collection</h5>
              <Link to={`#`} className="view_link">
                View All <img src={"/assets/images/viewall.svg"} alt="" />
              </Link>
            </div>
          </li>

          <li>
            <div className="dashboard_num">
              <h3>{financeData?.yearly_plan_collection}</h3>
              <h5>Yearly Plan Collection</h5>
              <Link to={`#`} className="view_link">
                View All <img src={"/assets/images/viewall.svg"} alt="" />
              </Link>
            </div>
          </li>
        </ul>
      </div>
  );
}
